export default __webpack_public_path__ + "static/media/timer-icon.664e162f.svg";